/**
 * @file Language Select Directive
 * @description This file contains the implementation of language select directive in an AngularJS application.
 * The directive allows the user to select a language from a dropdown menu and change the language of the application.
 * It also includes functions to convert language codes to locale keys and vice versa.
 * The file also includes a run block that handles language change events and updates the user's language preference.
 * @module app.locale
 */
(function () {
    'use strict';

    // WebView detection utility function
    window.isWebView = function() {
        // iOS WebView detection (Banking apps like Yapı Kredi, İşCep)
        if (window.webkit && window.webkit.messageHandlers) {
            return true;
        }
        
        // Android WebView detection (Banking apps like Yapı Kredi, İşCep)
        if (window.miniapp || window.myJSHandler) {
            return true;
        }
        
        return false;
    };

    window.langCode = function (_localeKey) {
        switch (_localeKey || window.lang) {
            case 'tr':
                return 1;
            case 'en':
                return 2;
            case 'es-ES':
                return 3;
            case 'pt-PT':
                return 4;
            default:
                return 1;
        }
    };
    window.langIso = function (backend_key) {
        switch (backend_key) {
            case 1:
                return 'tr';
            case 2:
                return 'en';
            case 3:
                return 'es-ES';
            case 4:
                return 'pt-PT';
            default:
                return 'tr';
        }
    };

    window.countryIso = function (backend_key) {
        switch (backend_key) {
            case 1:
                return 'turkiye';
            case 2:
                return 'espana';
            case 3:
                return 'portugal';
            default:
                return 'turkiye';
        }
    };

    angular.module("app.locale").run(['user_factory', '$state', 'LocaleService', '$rootScope', '$interval', '$stateParams', '$translate', 'userSvc', '$q', 'CacheFactory', '$timeout', function (user_factory, $state, LocaleService, $rootScope, $interval, $stateParams, $translate, userSvc, $q, CacheFactory, $timeout) {
        $rootScope.changeLanguageRoot = function (locale, code) {
            var localeKey;
            if (!code) {
                if (locale === 'Türkçe') {
                    localeKey = 'tr';
                } else if (locale === 'English') {
                    localeKey = 'en';
                } else if (locale === 'Español') {
                    localeKey = 'es-ES';
                } else if (locale === 'Português') {
                    localeKey = 'pt-PT';
                }
            }
            else {
                localeKey = code;
                if (localeKey === 'tr') {
                    locale = 'Türkçe';
                } else if (localeKey === 'en') {
                    locale = 'English';
                } else if (localeKey === 'es-ES') {
                    locale = 'Español';
                } else if (localeKey === 'pt-PT') {
                    locale = 'Português';
                }
            }

            if (localeKey === $translate.use()) return;


            $rootScope.changeCurrency(localeKey === "tr" ? "TRY" : "EUR", true);

            $rootScope.country = localeKey === 'pt-PT' ? 'portugal' : localeKey === 'es-ES' ? 'espana' : localeKey === 'tr' ? 'turkiye' : 'world';

            var updatedUser = updateLang(localeKey);
            updatedUser.then(function () {
                var clone = angular.copy($stateParams);
                clone.langcode = localeKey;
                window.localStorage.setItem('Language', localeKey);

                var translated = 0;
                LocaleService.setLocaleByDisplayName(locale).then(function () {
                    const name = $state.current.name.split('.')[0];
                    $timeout(function () {
                        if (clone.path) {
                            $translate(name).then(function (translation) {
                                clone.path = translation;
                            }).finally(function () { translated++; });
                        }
                        else
                            translated++;
                        if (clone.path2) {
                            const name2 = $state.current.name.split('.')[1];
                            $translate(name2).then(function (translation) {
                                clone.path2 = translation;
                            }).finally(function () { translated++; });
                        }
                        else
                            translated++;
                        if (clone.path3) {
                            const name3 = $state.current.name.split('.')[2];
                            $translate(name3).then(function (translation) {
                                clone.path3 = translation;
                            }).finally(function () { translated++; });
                        }
                        else
                            translated++;

                        if (clone.satilik) {
                            $translate(clone.satilik).then(function (translation) {
                                clone.satilik = translation;
                            }).finally(function () { translated++; });
                        }
                        else
                            translated++;

                        if (clone.konut) {
                            $translate(clone.konut).then(function (translation) {
                                clone.konut = translation;
                            }).finally(function () { translated++; });
                        }
                        else
                            translated++;
                    });

                    if (name !== "publishlisting")
                        var inter = $interval(function () {
                            if (translated === 5) {
                                $interval.cancel(inter);
                                if (name === "analysis" || name === 'atlas') {
                                    // Check if coming from banking app WebView
                                    if (window.isWebView()) {
                                        return;
                                    } else {
                                        // Normal browser: use window.location.href (required for map rendering)
                                        window.location.href = $state.href($state.current.name, clone);
                                    }
                                }
                                else {
                                    $state.go($state.current.name, clone, { notify: true, reload: true, inherit: false });
                                }
                            }
                        });
                });
                $rootScope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
            });
        };

        function updateLang(_localeKey) {
            var deferred = $q.defer();
            const code = window.langCode(_localeKey);
            if (userSvc.info.SignedIn && userSvc.info.Details.language !== code) {
                userSvc.info.Details.language = code;
                user_factory.language({ language: code }).$promise.then(null,
                    function () {
                        userSvc.info.SignedIn = false;
                        $rootScope.SignedIn = false;
                        CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                        CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                    }
                ).finally(function () {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        $rootScope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();

    }]);



    angular.module('app.locale')
        .directive('languageSelect', [languageSelect]);

    angular.module('app.locale')
        .directive('languageSelectTop', [languageSelectTop]);

    function languageSelect() {
        var directive = {
            restrict: 'A',
            replace: true,
            template: '<div id="mtranslateMenu">' +
                '<select selectpicker class="select-lang" ng-model="$root.currentLocaleDisplayName"' +
                'ng-change="$root.changeLanguageRoot($root.currentLocaleDisplayName)">' +
                '<option ng-selected="$root.currentLocaleDisplayName == \'English\'" value="English" data-content="<span class=\'flag-icon flag-icon-us\'></span> <span class=\'couname\'>English</span>"></option>' +
                '<option ng-selected="$root.currentLocaleDisplayName == \'Español\'" value="Español" data-content="<span class=\'flag-icon flag-icon-es\'></span> <span class=\'couname\'>Español</span>"></option>' +
                '<option ng-selected="$root.currentLocaleDisplayName == \'Português\'" value="Português" data-content="<span class=\'flag-icon flag-icon-pt\'></span> <span class=\'couname\'>Português</span>"></option>' +
                '<option ng-selected="$root.currentLocaleDisplayName == \'Türkçe\'" value="Türkçe" data-content="<span class=\'flag-icon flag-icon-tr\'></span> <span class=\'couname\'>Türkçe</span>"></option>' +
                '</select>' +
                '</div>'
        };

        return directive;
    }

    function languageSelectTop() {
        var directive = {
            restrict: 'A',
            replace: true,
            template: '<ul class="subnav" id="translateMenu">' +
                '<li class="{{$root.currentLocaleDisplayName == \'English\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeLanguageRoot(\'English\')"><span class="flag-icon flag-icon-us"></span> <span class="couname">English</span></a></li>' +
                '<li class="{{$root.currentLocaleDisplayName == \'Español\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeLanguageRoot(\'Español\')"><span class="flag-icon flag-icon-es"></span> <span class="couname">Español</span></a></li>' +
                '<li class="{{$root.currentLocaleDisplayName == \'Português\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeLanguageRoot(\'Português\')"><span class="flag-icon flag-icon-pt"></span> <span class="couname">Português</span></a></li>' +
                '<li class="{{$root.currentLocaleDisplayName == \'Türkçe\' ? \'subnav-item active\' : \'subnav-item\' }}"><a href="javascript:void(0)" ng-click="$root.changeLanguageRoot(\'Türkçe\')"><span class="flag-icon flag-icon-tr"></span> <span class="couname">Türkçe</span></a></li>' +
                '</ul>'
        };

        return directive;
    }
})();